import { useEffect } from "react";

const usePageReset = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default usePageReset;
